// Render de un bloque speaking tipo `over_to_you` con variante imagen / video / sin media.

import type { SpeakingBlock } from '@/services/lessons';
import { safeHtml } from '@/utils/safeHtml';
import styles from './SpeakingBlockView.module.scss';

interface SpeakingBlockViewProps {
  block: SpeakingBlock;
}

function youtubeEmbedUrl(url: string): string | null {
  const m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export function SpeakingBlockView({ block }: SpeakingBlockViewProps) {
  const ytEmbed = block.media_type === 'video' && block.media_url ? youtubeEmbedUrl(block.media_url) : null;
  return (
    <article className={styles.block}>
      <header className={styles.header}>
        <span className={styles.tag}>Speaking {block.block_index}</span>
        {block.title && <h3 className={styles.title}>{block.title}</h3>}
      </header>

      {block.media_type === 'image' && block.media_url && (
        <div className={styles.mediaWrap}>
          <img src={block.media_url} alt={block.title ?? ''} className={styles.media} />
        </div>
      )}

      {block.media_type === 'video' && block.media_url && (
        <div className={styles.mediaWrap}>
          {ytEmbed ? (
            <iframe
              src={ytEmbed}
              title={block.title ?? 'Video'}
              className={styles.media}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video src={block.media_url} controls className={styles.media} />
          )}
        </div>
      )}

      {block.content && (
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: safeHtml(block.content) }} />
      )}
    </article>
  );
}
